import React from 'react'
import { getDateFormat } from '../../Config/functions'

export const MessageHistory = ({data}:any) => {

    return (
        <div className="col-sm-12 card py-5 mt-5">
            <div className="row">
                <div className="col-sm-12 px-4">
                    <h4>Message History</h4>
                
                    {data!=null && data.length >0 ?
                   
                   data.map((el:any) =>
                     (
                    <table className="table table-striped border-0 mt-4">
                        <tbody>
                            <tr>
                                <th scope="row">Message Name</th>
                                <td>{el.type}</td>
                                <th scope="row">Date & Time:</th>
                                <td>{el.date ? `${getDateFormat(el.date.split("/")[0])}-${el.date.split("/")[1]}` : ""}</td>
                                <th scope="row">Template Name:</th>
                                <td>{el.template}</td>
                                
                            </tr>
                        </tbody>
                    </table>)) : "No Message History Available "}
                    
                </div>
            </div>

        </div>
    )
}
